import { Observable, Subscription } from 'rxjs';

/** TranslateService'in burada kullanilan kismi (test icin dar arayuz). */
export interface LangSource {
    currentLang: string;
    onLangChange: Observable<{ lang: string }>;
}

/**
 * <html lang> niteligini secili arayuz diliyle esitler. Tarayici CSS text-transform
 * (uppercase) kurallarini bu niteligin diline gore uygular; tr olmadan "Şirket" -> "ŞIRKET" olur.
 */
export function bindHtmlLang(source: LangSource, doc: Document): Subscription {
    if (source.currentLang) {
        doc.documentElement.lang = source.currentLang;
    }
    return source.onLangChange.subscribe((e) => {
        if (e.lang) {
            doc.documentElement.lang = e.lang;
        }
    });
}
